<template>
	<div>
		<modalwarehouse v-model="dialog" :propAdd='paramProp' :val='val'/>
		<modalconfirm ref="modalconfirmWarehouse" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Warehouse</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="tambah()">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Warehouse</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="warehouseResults" :search="search" hide-default-footer :options.sync="option" :server-items-length="warehousePagination.total_data">
				<template v-slot:item.warehouse_name="{ item }">
					<div class="pl-2 my-auto">{{ item.warehouse_name }}</div>
				</template>
				<template v-slot:item.contact="{ item }">
					<div class="pb-2">{{ item.warehouse_mobilephone }}</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div class="pt-2 text-capitalize">{{ item.warehouse_address }}</div>
				</template>
				<template v-slot:item.warehouse_area_name="{ item }">
					<div class="pl-2 my-auto text-capitalize">{{ item.warehouse_area_name }}</div>
				</template>
				<template v-slot:item.warehouse_is_active="{ item }">
					<v-switch v-model="item.warehouse_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom v-if="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click.stop="hapus(item.warehouse_id, item.warehouse_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!warehousePagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="warehousePagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="warehousePagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalwarehouse from '@/views/MLwarehouse/warehouse/ModalWarehouse'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalwarehouse
	},
	data() {
		return {
			messages: '',
			propDelete: '',
			page: 1,
			sortBy: 'warehouse_name',
			sortDir: 'ASC',
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Warehouse', align: 'start', sortable: true,	value: 'warehouse_name'},
			{ text: 'No. Handphone', value: 'contact', sortable: false},
			{ text: 'Alamat', value: 'address', width: '30%', sortable: false },
			{ text: 'Warehouse Area', value: 'warehouse_area_name' },
			{ text: 'Aktif', value: 'warehouse_is_active', sortable: false, },
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'text',
				label: 'Nama Warehouse',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'warehouse_name'
				}
			}, {
				type: 'text',
				label: 'No Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'warehouse_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Alamat',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'warehouse_address'
				}
			}, {
				type: 'selection',
				label: 'Warehouse Area',
				item: [],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'warehouse_area_id'
				}
			},
			],
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	computed: {
		...mapState('warehouseList', ['warehouseResults', 'warehousePagination', 'konfirmResponse', 'warehouseArea', 'responSukses']),
	},
	methods: {
		...mapActions('warehouseList', ['getWarehouse', 'getWarehouseAreaOption', 'status', 'delete', 'exportWarehouse']),
		...mapMutations('warehouseList', ['clearDataWarehouse']),
		...mapActions('maps', ['getGeolocation']),
		...mapMutations('maps', ['setLocation']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			this.getWarehouse(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			this.exportWarehouse(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmWarehouse.setMessage(msg)
			this.$refs.modalconfirmWarehouse.showConfirm()
		},
		tambah() {
			this.dialog=true;
			this.paramProp='tambah';
			this.val= {};
		},
		ubah(item){
			this.val = item;
			this.dialog = true;
			this.paramProp ='edit';
			this.setLocation({lat:parseFloat(item.warehouse_latitude), lng:parseFloat(item.warehouse_longitude)})
		},
		async deleteData () {
			await this.setOverlay(true)
			await this.$refs.modalconfirmWarehouse.hideConfirm()
			await this.delete(this.propDelete).then( () => {
				if(this.responSukses.code == 200) {
					this.getData()
				}
			})
			await this.setOverlay(false)
		},
		editStatus(stat){
			this.paramStatus.id = stat.warehouse_id
			if(stat.warehouse_is_active == false){
				this.paramStatus.status = 'inactive'
			} else{
				this.paramStatus.status = 'active'
			}
			this.status(this.paramStatus).then(() => {
				this.getData()
			})
		},
	},
	async created() {
		let indexArea = await this.filterData.findIndex(el => el.label == 'Warehouse Area')
		this.filterData[indexArea].item = await this.getWarehouseAreaOption()
		await this.setFilter(this.filterData)

		await this.getGeolocation();
		this.$store.dispatch('setPageTitle', `Warehouse`);
		await this.getData()
	},
	beforeDestroy(){
		this.clearDataWarehouse()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>